<template lang="pug">
li.list--spaces-subscribed
  .list--spaces-subscribed-item
    .list--spaces-subscribed-wrapper
      .list--spaces-subscribed-headline
        .list--spaces-type(v-if="space.space_type_sym")
          i.font-awesome-icon(v-bind:class="['fa', spaceTypeIcon]")
          | {{space.space_type_name}}
        .list--spaces-subscribed-title
          a.list--spaces-subscribed-name(v-bind:href="'/spaces/' + space.name_url") {{space.name}}
          span.list--spaces-subscribed-address {{space.prefecture.name}}{{space.city.name}}{{space.address}}
        span.list--spaces-subscribed-pr PR
      .list--spaces-subscribed-cover(v-bind:style="{ 'background-image': 'url(\"' + space.display_image_main_wide_medium + '\")' }")
        .list--spaces-subscribed-gradient
          p.list--spaces-subscribed-description {{space.catchcopy}}
          .list--spaces-subscribed-spec
            .list--spaces-subscribed-logo
              img(v-bind:src="space.image_logo.url")
            .list--spaces-subscribed-opening
              span 平日：{{space.weekday_opening_hours}}
              br
              span 休日：{{space.holiday_opening_hours}}
            ul.list--spaces-subscribed-info
              li.list--spaces-subscribed-data
                .list--spaces-subscribed-data-label ボードゲーム
                .list--spaces-subscribed-data-value
                  a(v-bind:href="'/spaces/' + space.name_url + '/games'")
                    | {{space.ourgames_size}}個
              li.list--spaces-subscribed-data
                .list--spaces-subscribed-data-label 開催イベント
                .list--spaces-subscribed-data-value
                  a(v-bind:href="'/spaces/' + space.name_url + '/events'")
                    | {{space.alive_space_events_size}}件のイベント
                  | を予定
              li.list--spaces-subscribed-data
                .list--spaces-subscribed-data-label 平均予算
                .list--spaces-subscribed-data-value(v-if="space.charge_avg") 約{{space.charge_avg}}円前後
                .list--spaces-subscribed-data-value(v-else) 登録されていません
            button.list--spaces-subscribed-follow.watch(
                v-if="space.current_user_followable"
                v-bind:class="{ on: space.current_user_following }"
                v-on:click="toggleFollow"
              )
                i.font-awesome-icon(class="fa fa-rss")
                | {{ space.current_user_following ? 'フォロー中' : 'フォローする' }}
</template>

<script>
export default {
  props: {
    initialSpace: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      space: this.initialSpace
    };
  },
  computed: {
    spaceTypeIcon: function() {
      const space_type_icons = {
        cafe: 'fa-coffee',
        space: 'fa-object-ungroup',
        bar: 'fa-glass-martini',
        other: 'fa-shopping-cart'
      };
      return space_type_icons[this.space.space_type_sym];
    },
  },
  methods: {
    toggleFollow() {
      this.$emit('toggle-follow', this.space);
    }
  }
};
</script>
<style scoped lang="scss">
@import "app/assets/stylesheets/_mixin.scss";
@import "app/assets/stylesheets/_variable.scss";
.watch {
  @include border-radius();
  font-size: $common-normal;
  font-weight: bold;
  border: 1px solid #ddd;
  color: #333;
  background-color: #fff;
  padding: 12px 0;
  text-decoration: none;
  display: block;
  width: 100%;
  i.font-awesome-icon {
    color: #ccc;
  }
  &:hover {
    color: $common-orange;
    i.font-awesome-icon {
      color: $common-orange;
    }
  }
  &.on {
    @include text-shadow();
    background-color: $common-orange;
    color: #fff;
    border-color: adjust-color($common-orange, $red: -34, $green: -34, $blue: -34);
    i.font-awesome-icon {
      color: #fff;
    }
    &:hover {
      background-color: adjust-color($common-orange, $red: 34, $green: 34, $blue: 34);
    }
  }
}
</style>
